import { isFiveStarService } from '@services/memberBenefitsService';
import React from 'react';
export interface StaticContentProps {
	servicesContent?: ServiceContent[];
	isFiveStarMemberPricingEnabled?: boolean;
}

function StaticContent(props: StaticContentProps) {
	const isFiveStarMemberPricingEnabled = props.isFiveStarMemberPricingEnabled;

	return (
		<div data-testid="services-component" className={``}>
			<ul>
				{props.servicesContent?.map((s, index) => {
					const hasMemberSaving =
						isFiveStarMemberPricingEnabled && isFiveStarService(s.title);

					return (
						<li key={s.title} className="mt-4">
							<div className="text-title mb-2" data-testid={`service-${index}`}>
								{s.title}
							</div>
							<div className="service-pricing bg-gray-10 rounded p-3 text-gray-100 text-title">
								{hasMemberSaving && (
									<div className="bg-gray-10 flex justify-between">
										<div className="font-regular">AO member price</div>
										<div className="text-deals">Free</div>
									</div>
								)}

								<div className="bg-gray-10 flex justify-between">
									<div className={`${hasMemberSaving && 'font-regular'}`}>
										{hasMemberSaving ? 'Regular price' : 'Price'}
									</div>
									<div>{s.price}</div>
								</div>
							</div>
							<div
								data-testid={`service-content-${index}`}
								className="text-body-sm font-body ao-framework"
								dangerouslySetInnerHTML={{ __html: s.content }}
							></div>
						</li>
					);
				})}
			</ul>
		</div>
	);
}

export default StaticContent;
